import CafeteriaOrdersTable from './lib/table';
import { useTypedSelector } from 'common/hooks/useTypedSelector';

import PageTitle from 'components/pageTitle';

import * as S from './styles';

export default function CafeteriaOrdersListPage() {
  const { orders }: any = useTypedSelector((state) => state.Cafeteria);

  return (
    <S.Container>
      {/* The heading is drawn by the topbar. This screen has no page-level
          action, so the head row that used to hold one is gone rather than
          left behind as an empty flex container with a gap under it. */}
      <PageTitle title="Orders List" />

      <CafeteriaOrdersTable menuList={orders?.data} loading={orders?.loading} />
    </S.Container>
  );
}
